import type { LiveEditorDraftRow } from '@/components/live-editor/types';
import type { LiveEditorOpDialogMode } from '@/components/live-editor/op-stage-dialog.vue';
import {
  addCalendarDays,
  LIVE_CLOSE_PLAN_DAYS,
  liveClosePlanDateForRow,
  liveReplyPlanDate,
  liveReplyPlanDateForRow,
} from '@/domain/live-case';

/** 编辑器草稿行与 LiveCase 共用的计划日字段 */
export type StagePlanRow = {
  date: string;
  replyPlanDate?: string | null;
  planDate?: string;
  patch?: { planDate?: string };
};

export function closePlanDateRaw(row: StagePlanRow): string {
  return row.patch?.planDate ?? row.planDate ?? '';
}

export function stagePlanRowFromDraft(row: LiveEditorDraftRow): StagePlanRow {
  return {
    date: row.date || '',
    replyPlanDate: row.replyPlanDate,
    patch: { planDate: row.patch.planDate },
  };
}

export function stagePlanDefault(mode: LiveEditorOpDialogMode, row: StagePlanRow): string {
  if (mode === 'close') {
    const date = row.date || '';
    return date ? addCalendarDays(date, LIVE_CLOSE_PLAN_DAYS) : '';
  }
  return liveReplyPlanDate(row.date || '') || '';
}

export function stagePlanDateForOp(mode: LiveEditorOpDialogMode, row: StagePlanRow): string {
  if (mode === 'close') {
    return liveClosePlanDateForRow({ date: row.date || '', planDate: closePlanDateRaw(row) });
  }
  return liveReplyPlanDateForRow({ date: row.date || '', replyPlanDate: row.replyPlanDate });
}
